import { ResponsePriceInfoModel } from './index';
export class ResponseLineItemModel {

  priceInfo: ResponsePriceInfoModel;
  quantity: number;
  productId: string;
  itemCode: string;
}
